import template from "./rejection-reason.html";

//rejection-reason-modal
export function controller() {
	const ctrl = this;

	ctrl.handleCancel = handleCancel;
	ctrl.handleReject = handleReject;

	function handleCancel() {
		ctrl.modalInstance.dismiss();
	}
	
	function handleReject() {
		ctrl.modalInstance.close(ctrl.reason);
	}
}

export default angular
	.module("vesl.components.rejection-reason-modal", [])
	.component("rejectionReasonModal", {
		controller,
		template,
		bindings: {
			modalInstance: "<"
		}
	}).name;